import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useAuth } from '../providers'
import { v1Client } from '../api'
import { useGlobalEvent } from '@highlight/ipc'
import { CHAT_HISTORY_QUERY_KEY, HISTORY_PREVIEW_QUERY_KEY } from '@renderer/stores/conversation-query-keys'

const RETRY_ATTEMPTS = 5

export function useInvalidateHistoryPreview() {
  const queryClient = useQueryClient()
  return () => {
    queryClient.invalidateQueries({ queryKey: [HISTORY_PREVIEW_QUERY_KEY] })
  }
}

export function useInvalidateChatHistory() {
  const queryClient = useQueryClient()
  return () => {
    queryClient.invalidateQueries({ queryKey: [CHAT_HISTORY_QUERY_KEY] })
  }
}

export function useHistoryPreview() {
  const { getAuthToken } = useAuth()
  const queryClient = useQueryClient()

  // Listen for chat:history:invalidate events from electron renderer
  useGlobalEvent('chat:history:invalidate', () => {
    queryClient.invalidateQueries({ queryKey: [HISTORY_PREVIEW_QUERY_KEY] })
  })

  return useQuery({
    queryKey: [HISTORY_PREVIEW_QUERY_KEY],
    queryFn: async () => {
      const response = await v1Client.GET('/conversations', {
        params: {
          query: {
            limit: 20,
          },
        },
        headers: {
          Authorization: `Bearer ${await getAuthToken()}`,
        },
      })

      if (response.error) {
        console.log(response.error)
        throw new Error('Network response was not ok')
      }

      const data = response.data.data
      return data
    },
    gcTime: 60000,
    retry: RETRY_ATTEMPTS,
    retryDelay: (attemptIndex) => {
      // Exponential backoff: 2s, 4s, 8s, 10s, 10s
      return Math.min(2000 * 2 ** attemptIndex, 10000)
    },
  })
}
